module.exports = __webpack_public_path__ + "img/ennetix-application-detail-page-users-tab2.5c548902.png";